module.exports = __webpack_public_path__ + "static/media/Logo_Trust_SAS.3bcf4cb0.png";